<template>
  <!--  国民经济-->
  <div class="waiceng">
    <el-menu
        :default-active="dictDataType"
        class="el-menu-vertical-demo"
        :unique-opened="true"
        @select="selectChange">
      <el-submenu index="现价">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">现价</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_present_price">GDP:现价:当季值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="不变价">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">不变价</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_unchange_price">GDP:不变价:当季值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="三次产业对GDP贡献">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">三次产业对GDP贡献</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_three_price">GDP累计同比贡献率</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_three_industry">GDP累计同比贡献率:工业</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_three_construction">GDP累计同比贡献率:建筑业</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_three_finance">GDP累计同比贡献率:金融业</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_three_estate">GDP累计同比贡献率:房地产业</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="固定资产投资">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">固定资产投资</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_fixed_amount">固定资产投资完成额:累计值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_fixed_exploitation">固定资产投资完成额:煤炭开采和洗选业:累计同比</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_fixed_manufacture">固定资产投资完成额:制造业:累计同比</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_fixed_chemistry">固定资产投资完成额:制造业:化学原料及化学制品制造业:累计同比</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_fixed_metal">固定资产投资完成额:制造业:黑色金属冶炼及压延加工业:累计同比</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="社会消费">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">社会消费</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_social_consumption">社会消费品零售总额:当月值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="进出口">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">进出口</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_exit_exit_price">进出口金额:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_exit_export_price">出口金额:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_exit_import_price">进口金额:当月值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <Detail class="detail" :dictDataType="dictDataType"></Detail>
  </div>
</template>

<script>
import Detail from '@/components/macroscopic/detail'

export default {
  name: "economics",
  components: {
    Detail
  },
  data() {
    return {
      dictDataType: 'issue_macroscopic_present_price',
    }
  },
  created() {
  },
  methods: {
    /**
     * 切换详情
     * @param index
     */
    selectChange(index) {
      this.dictDataType = index;
    }
  },
}
</script>

<style scoped lang="less">
.detail {

}

.el-menu {
  color: #222222;
  display: inline-block;
  vertical-align: top;
  width: 236px;
  min-height: 688px;
  box-shadow: 0px 2px 10px 0px rgb(183 183 183 / 50%);
}

.redIcon {
  display: inline-block;
  width: 4px;
  height: 4px;
  background: #D3131A;
  border-radius: 1px;
  font-style: normal;
  margin-right: 15px;
  vertical-align: middle;
}

.write {
  font-style: normal;
  vertical-align: middle;
  display: inline-block
}
</style>
